export enum RequestStatus {
  inProgress= 'InProgress',
  completed = 'Completed',
  rejected = 'Rejected',
  cancelled = 'Cancelled',
  expired = 'Expired',
  failed = 'Failed'
}